export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./slots-filter.vue?vue&type=template&id=34525680"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/slots-filter/slots-filter.vue?vue&type=template&id=34525680
// module id = 42YT
// module chunks = 0